export const fetchInstance: typeof fetch = async (input, init) => {
  const response = await fetch(input, init)
  if (!response.ok) {
    console.error(response)
    throw new Error('fetch instance error', {
      cause: response,
    })
  }

  return response
}
